import React from "react";
import { useNavigate } from 'react-router-dom';
import Footer from '../components/SFooter';
import Header from '../components/Header';
import HeroSection from '../components/HeroSection';
import { Button } from '@mui/material';
import { useTranslation } from 'react-i18next';

export default function AboutUs() {
  
    const navigate = useNavigate();
    const { t } = useTranslation();
  return (
<>
      <Header/>
      <HeroSection/>
    <div className="w-full min-h-screen bg-gray-50 py-12 px-6 flex justify-center">
      <div className="max-w-4xl bg-white rounded-2xl shadow-xl p-10">
        <h1 className="text-3xl font-bold text-gray-800 mb-6 text-center">
          About Us
        </h1>

        <p className="text-gray-600 text-lg leading-relaxed mb-6">
          Welcome to Foodsakz platform, your online grocery shopping destination for quality food products.
We offer a wide selection of seasonal vegetables and fruits, meat, grains, spices, coffee and
tea to your home or office.
        </p>
      <p>
      Foodsakz is a partnership firm established in Chennai, Tamil Nadu. We work with trusted
suppliers to provide a wide variety of products to ensure that everyone has access to fresh
and quality ingredients. We believe that food should be delicious and nutritious. Foodsakz is
here to provide exceptional quality at competitive prices.
      </p>
        <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-3">
          Our Vision
        </h2>
        <p className="text-gray-600 leading-relaxed mb-6">
          To build the most trusted and efficient digital ecosystem where suppliers
          can showcase their capabilities and buyers can seamlessly discover the
          right partners for their needs.
        </p>
<h2 className="text-2xl font-semibold text-green-800 mt-8 mb-3">
What We Offer
</h2>
<ul className="text-gray-700 space-y-3 list-disc pl-6">
<li>Fast home delivery of fresh groceries</li>
<li>Wide range of fruits, vegetables, and daily essentials</li>
<li>Easy online ordering with secure payments</li>
<li>Exclusive deals and discounts for regular shoppers</li>
<li>Quality products sourced directly from trusted suppliers</li>
</ul>


<h2 className="text-2xl font-semibold text-green-800 mt-8 mb-3">
Why Choose Us?
</h2>
<p className="text-gray-600 leading-relaxed mb-6">
We prioritize freshness, reliability, and customer satisfaction. With our
seamless ordering experience and fast delivery service, you can skip the
queues and enjoy hassle-free grocery shopping from the comfort of your
home.
</p>


<div className="text-center mt-10">
    
           <Button variant="contained" color="primary" href="/">
         {t('browse_products' , 'Browse Products')}    
        </Button>
</div>
      </div>
    </div>
      <Footer/>
      </>
  );
}
